import PropTypes from 'prop-types';

const displayName = 'Button';
const propTypes = {
  children: PropTypes.any,
  addClass: PropTypes.string,
  action: PropTypes.func,
  id: PropTypes.string,
  style: PropTypes.object,
};
const defaultProps = {};

export default { propTypes, defaultProps, displayName };
